import { SortOrder } from '~modules/media-library/model/SortOrder';
export const DEFAULT_SORT_KEY = 'DEFAULT';

export type SortOption = {
  key: string;
  label: string;
  asc: string;
  desc: string;
  default: SortOrder;
};

export type SortOptionMap = Map<SortOption['key'], SortOption>;
